


 <div id="scanner-content" class="scanner-page">

    <dx-load-panel #loadPanel container="#scanner-content" [showIndicator]="true" shadingColor="rgba(0,0,0,0.2)"
    [showPane]="false" [shading]="true" [visible]="scannerProcessLoaded" [position]="{ of: '#scanner-content' }"></dx-load-panel>
    
    

 
    
    <div class="scanner-preview">
      <div class="scanner-operations">
        <dx-button [disabled]="saveDocDisabled"  hint="90° döndür" icon="refresh" (onClick)="rotateImage()"> </dx-button>
         <dx-button [disabled]="saveDocDisabled" hint="Kontrast arttır" icon="assets/images/sun-solid.svg" (onClick)="changeImageContrast(true)"> </dx-button>
        <dx-button [disabled]="saveDocDisabled" hint="Kontrast azalt" icon="assets/images/sun-regular.svg" (onClick)="changeImageContrast(false)"> </dx-button>
        <dx-button [disabled]="saveDocDisabled" hint="Parlaklık arttır" icon="assets/images/moon-solid.svg" (onClick)="changeImageBrightness(true)"> </dx-button>
        <dx-button [disabled]="saveDocDisabled" hint="Parlaklık azalt" icon="assets/images/moon-regular.svg" (onClick)="changeImageBrightness(false)"> </dx-button>
        <dx-button [disabled]="saveDocDisabled" hint="Kes" icon="cut" (onClick)="cropImage()"> </dx-button>
        <!-- <dx-button hint="Zoom IN" icon="plus" (onClick)="zoom(true)"> </dx-button>
        <dx-button hint="Zoom OUT" icon="minus" (onClick)="zoom(false)"> </dx-button> -->
        
        <dx-button [disabled]="(saveDocDisabled && !showPdfYn)" hint="Büyüt" icon="expandform" (onClick)="showFullSizeDoc=true"> </dx-button>

        <dx-button [disabled]="saveDocDisabled" hint="Sayfa Sil" icon="close" (onClick)="openPageRemovalDialog()"> </dx-button>

    
      </div>

    


      <input   type="image" class="scanned-img" id="previewImage" alt="" [width]="imgWidth" [height]="imgHeight" />


         <iframe
        [width]="imgWidth" [height]="imgHeight"
        type="application/pdf"
          *ngIf="showPdfYn && fileUrl"
          [src]="fileUrl"
          (load)="onDocumentLoad()"
          (error)="onFileError()"
        ></iframe>
 




      <div class="page-buttons"  *ngIf="false">
 
  
      <dx-button icon="chevrondoubleleft" (onClick)="changePage(0)"> </dx-button>
      <dx-button icon="back" (onClick)="changePage(focusImageIndex-1)"> </dx-button>
      <div id="imagesInfo" class="imagesInfo">{{pageInfo}}</div>
      <dx-button icon="chevronnext" (onClick)="changePage(focusImageIndex+1)"> </dx-button>
      <dx-button icon="chevrondoubleright" (onClick)="changePage(acquiredImages.get_Count()-1)"> </dx-button>
 
   
    </div>
 
    </div>


    <div class="scanner-options">
      <h4 class="scanner-label">VintaSoft</h4>
      <dx-select-box
      [label]="'Cihaz:'"
      [labelMode]="'outside'"
      [dataSource]="scannerDevices"
      placeholder="Cihaz Seçiniz"
      (selectedItemChange)="getSelectedDevice($event)"
      displayExpr="name"
      valueExpr="name"
      [value]="selectedScannerDevice"

    >
    </dx-select-box>
  
    <dx-select-box
    [dataSource]="documentPixelTypes"
    placeholder="Renk Tipi Seçiniz"
    [label]="'Renk Tipi:'"
    [labelMode]="'outside'"
    (selectedItemChange)="getSelectedPixelType($event)"
    [displayExpr]="'name'"
    [valueExpr]="'value'"
    [value]="selectedDocumentPixelType"
  >
  </dx-select-box>
  
  
  <dx-select-box
  [dataSource]="documentResolutionTypes"
  placeholder="Çözünürlük Seçiniz"
  [label]="'Çözünürlük:'"
    [labelMode]="'outside'"
  (selectedItemChange)="getSelectedResolutionType($event)"
  [displayExpr]="'name'"
  [valueExpr]="'value'"
  
  [value]="selectedDocumentResolution"
  >
  </dx-select-box>
  
  
  
  <dx-select-box
  [dataSource]="documentExportType"
  placeholder="Belge Tipi Seçiniz"
  [label]="'Belge Tipi:'"
  [labelMode]="'outside'"
  (selectedItemChange)="getSelectedDocType($event)"
  [displayExpr]="'name'"
  [valueExpr]="'name'"
  [value]="selectedDocumentExportType"
  >
  </dx-select-box>

  
  <div class="scanner-check-options">
    <dx-check-box 
    text="ADF Kullan"
    [(value)]="useAdf"
    (onValueChanged)="useAdf=$event.value">

  
</dx-check-box>

<dx-check-box 
text="Duplex Tara"
[(value)]="useDuplex"
(onValueChanged)="useDuplex=$event.value">
</dx-check-box>


<dx-check-box 
text="UI Göster"
[(value)]="showUI"
(onValueChanged)="showUI=$event.value">


</dx-check-box>

</div>

  
  
      <dx-button
              [disabled]="scanButtonDisabled"
              [text]="'Tarama Yap'"
              type="default"
              stylingMode="contained"
              (click)="acquireImagesFromTwainDevice()"
            ></dx-button>


            <dx-button
            [disabled]="saveDocDisabled"
            [text]="'Kaydet'"
            type="default"
            stylingMode="contained"
            (click)="exportFileAsBase64Content()"
              ></dx-button>
              <a style="margin-left:auto;margin-right:auto" href="assets/VintasoftWebTwainService-15.1.0-setup.exe">Uygulamayı buradan indirebilirsiniz</a><br /> 

    </div>


  </div>




<ng-container *ngIf=" showPdfYn && showFullSizeDoc">

  <dx-popup
  [visible]="showPdfYn && showFullSizeDoc"
  [fullScreen]="true"

  title="PDF"
  (onHiding)="showFullSizeDoc = false"
  contentStyle="padding: 0;"
>
  <div *dxTemplate="let data of 'content'" style="width: 100%; height: 100%;">
    <iframe
      type="application/pdf"
      *ngIf="showPdfYn && fileUrl"
      [src]="fileUrl"
      (load)="onDocumentLoad()"
      (error)="onFileError()"
      style="width: 100%; height: 100%; border: none;"
    ></iframe>
  </div>
</dx-popup>

</ng-container>